import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

interface UseDeleteReviewAnalysisPlatformMutationParams {
  onError?: () => void
  onSuccess?: () => void
}

export const useDeleteReviewAnalysisPlatformMutation = (
  campaignId: string,
  { onError, onSuccess }: UseDeleteReviewAnalysisPlatformMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (cardId: string) =>
      ReviewAnalysisApiService.deleteReviewPlatform(campaignId, cardId),
    onError: () => {
      onError?.()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_STATUS, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGN, campaignId],
      })
      onSuccess?.()
    },
  })
}
